import { useEffect, useState } from 'react';
import { useGetDeckblattPDFMutation } from '../../api/AuftragAPI';
import DialogPdfComponent from '../DialogPdfComponent/DialogPdfComponent';

interface ThisProps {
//  uidAuftrag: string;
}

/**
 * @author noone
 */
const HinweisMessverfahrenDownloadButtonComponent: React.FC<ThisProps> = ({  }) => {

   const handleDownload = () => {
    const link = document.createElement("a");
    link.href = "/files/hinweise_messverfahren.pdf"; // Pfad zur PDF im public-Ordner
    link.download = "hinweise_messverfahren.pdf";     // gewünschter Dateiname
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <button className="btn btn-secondary" onClick={handleDownload}>
            <i className="bi bi-download"></i> Hinweise zu Messverfahren
          </button>
    </>
  );

}

export default HinweisMessverfahrenDownloadButtonComponent;